module.exports = __webpack_public_path__ + "static/media/background.59105ba5.avif";